// @flow
export const SendObjectTypes = {
  BOARD: 'board',
  PIN: 'pin',
  DID_IT: 'did_it',
  // 'pinner' instead of SendObjectTypes.USER because ShareInvite uses that
  // instead of 'user'
  PINNER: 'pinner',
  USER: 'user',
};

// NOTE(jackhhsu): duplicating definition because of https://github.com/facebook/flow/issues/961
export type SendObjectType = 'board' | 'pin' | 'did_it' | 'pinner' | 'user';

export default SendObjectTypes;
